// IMPORT REACT
import React from 'react';

// IMPORT STYLES
import { SC_Row } from '../styles';


const YARow = (props) => {    
    return (
    	<SC_Row {...props} className={props.center ? (props.center=='vertical'? 'align-items-center' : 'justify-content-center') : null}>
            {props.children}
        </SC_Row>
    )
    
}
export default YARow;